import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSearchBoxComponent } from './custom-search-box.component';
import {
  CmsConfig,
  ConfigModule,
  FeaturesConfigModule,
  I18nModule,
  UrlModule
} from "@spartacus/core";
import { RouterModule } from "@angular/router";
import { IconModule, MediaModule, OutletModule } from "@spartacus/storefront";
import { HighlightPipe } from "./highlight.pipe";
import { CustomSimpleProductListModule } from "../../../../../custom/cms-components/content/custom-simple-product-list/custom-simple-product-list.module";
import { CustomLinkListModule } from "../../../../../custom/cms-components/content/custom-link-list/custom-link-list.module";

@NgModule({
  declarations: [CustomSearchBoxComponent, HighlightPipe],
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    OutletModule,
    FeaturesConfigModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        CustomSearchBoxComponent: {
          component: CustomSearchBoxComponent,
        },
      },
      features: {
        recentSearches: false,
      },
    }),
    CustomSimpleProductListModule,
    CustomLinkListModule
  ]
})
export class CustomSearchBoxModule {}
